import React, { useRef, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import SignatureCanvas from "react-signature-canvas";
import { Block, Button, Loading } from "../../../components/Component";
import { apiRequest } from "../../../utils/Api";
import { useForm } from "react-hook-form";
import { Row, Spinner } from "reactstrap";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getStep } from "../../../utils/Utils";

const AmlConsent = ({ ...props }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const request_id = queryParameters.get("request_id");
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    getValues,
    setError,
    clearErrors
  } = useForm();
  const [sign, setSign] = useState();
  const [signError, setSignError] = useState();

  let signPad = useRef({});
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  const [load, setLoad] = useState(0);
  if (load < 1) {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setLoad(2);
  }

  useEffect(() => {
    // getUserInfo();
    register('conflicts-or-separate-representation')
  }, []);

  // const getUserInfo = async () => {
  //   await apiRequest("/ccr/kyc/" + request_id, "GET").then((resp) => {
  //     if (resp) {
  //       if (resp.code === 200) {
  //         console.log(resp);
  //         setValue("from_name", resp.data.request.from_name);
  //         setValue("from_company", resp.data.request.from_company);
  //         setLoading(false);
  //       }
  //     } else {
  //       toast.error("Something went wrong,Try again later", {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //       });
  //     }

  //     // console.log(getValues());
  //   });
  // };

  const onClear = () => {
    signPad.current.clear();
    setSign();
  };

  const locationAccess = async () => {
    return new Promise((resolve, reject) => {
      const options = {
        enableHighAccuracy: true, // Request high accuracy (GPS)
        timeout: 10000, // Set a timeout of 10 seconds
        maximumAge: 0, // Ensure the result is not a cached position
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // setValue("location", { latitude, longitude });
          resolve({ latitude, longitude });
        },
        (err) => {
          // Handle error
          console.log(err);
          resolve({ latitude: null, longitude: null });
        },
        options,
      );
    });
  };

  const onFormSubmit = async () => {

    console.log(signError)
    if (signPad && signPad.current && signPad.current.isEmpty()) return
    console.log('sign error')
    // return
    setSubmitButtonLoading(true);
    const location = await locationAccess();
    // setValue("latitude", location.latitude);
    // setValue("longitude", location.longitude);
    let data = {
      latitude: location.latitude,
      longitude: location.longitude
    }
    data.agreement = getValues()
    data.signature = signPad.current.getTrimmedCanvas().toDataURL()
    data.latitude = location.latitude || null
    data.longitude = location.longitude || null
    try {
      setLoading(true);
      await apiRequest(`/ccr/kyc/step/${await getStep('consent')}`, "POST", data).then((resp) => {
        if (resp) {
          if (resp.code === 200) {
            // console.log(resp);
            props.jump(resp.data.step);
          } else {
            console.log("error response: ", resp.message);
            setLoading(false)
            setSubmitButtonLoading(false);
          }
        } else {
          setSubmitButtonLoading(false);
        }
      });
    } catch (err) {
      console.log(err);
      setSubmitButtonLoading(true);
    }
  };


  const handleFormSubmit = async (event) => {
    event.preventDefault();
    // console.log('submit');
    console.log(signPad)
    if (signPad && signPad.current && signPad.current.isEmpty()) {
      setSignError("Please sign");
      setError('signature',
        { type: "required", message: "This field is required" }
      )
      // return;
    } else {
      clearErrors('signature')
      setSignError(null);
    }
    console.log(getValues('matter-participants-represent-clients'))
    if (getValues('matter-participants-represent-clients') && !getValues('conflicts-or-separate-representation')) {
      console.log('set')

    } else {
      console.log('clear')
    }

    console.log(errors)
    await handleSubmit(onFormSubmit)();

    if (Object.keys(errors).length || (signPad && signPad.current && signPad.current.isEmpty())) {
      toast.error('missing information', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <React.Fragment>
      {/* {sign && <img src={sign} alt='test'/>} */}
      <Head title="Attestation" />
      {/* <HeaderCCR></HeaderCCR> */}
      <div className=""></div>
      {loading && <Loading />}
      {!loading && (
        <Content>
          <div className="content-page wide-md m-auto mb-5">
            <Block className={submitButtonLoading && "disabled"}>
              <h5>Consents</h5>
              <p>You acknowledge, agree and consent to the following:</p>
              <form className="content clearfix" onSubmit={handleFormSubmit}>
                <div className="gy-4 row pb-5">
                  <div className="entry">

                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="matter-participants-defined"
                                // checked={true}
                                onSelect={() => {
                                  setValue("matter-participants-defined", !getValues("matter-participants-represent-clients"));
                                }}
                                {...register("matter-participants-defined", {
                                  required: "This field is required",
                                })}
                              />

                              <label className="custom-control-label" htmlFor="matter-participants-defined">
                                <div>
                                  For the purposes below the Requestor, its organization and Athenty are referred to collectively or individually as the Matter Participants.
                                </div>
                              </label>
                              {errors['matter-participants-defined'] && <p className="invalid">{errors['matter-participants-defined'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="matter-clients-defined"
                                // checked={true}
                                onSelect={() => {
                                  setValue("matter-clients-defined", !getValues("matter-clients-defined"));
                                }}
                                {...register("matter-clients-defined", {
                                  required: "This field is required",
                                })}
                              />

                              <label className="custom-control-label" htmlFor="matter-clients-defined">
                                <div>
                                  The clients for this Matter (the "Matter Clients") are:
                                </div>
                              </label>
                              {errors['matter-clients-defined'] && <p className="invalid">{errors['matter-clients-defined'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="verifications-on-matter-clients"
                                // checked={true}
                                onSelect={() => {
                                  setValue("verifications-on-matter-clients", !getValues("verifications-on-matter-clients"));
                                }}
                                {...register("verifications-on-matter-clients", {
                                  required: "This field is required",
                                })}
                              />

                              <label className="custom-control-label" htmlFor="verifications-on-matter-clients">
                                <div>
                                  The Matter Participants may complete verifications on any of the Matter Clients.
                                </div>
                              </label>
                              {errors['verifications-on-matter-clients'] && <p className="invalid">{errors['verifications-on-matter-clients'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <p>By checking the boxes below you acknowledge, agree and consent to the following:</p>
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="matter-participants-represent-clients"
                                checked={watch("matter-participants-represent-clients")}
                                {...register("matter-participants-represent-clients")}
                                onSelect={() => {
                                  setValue("matter-participants-represent-clients", !getValues("matter-participants-represent-clients"));
                                }}
                              />

                              <label className="custom-control-label" htmlFor="matter-participants-represent-clients">
                                <div>
                                  {/* The individual's information, their location, residency and contact information are true, accurate and current. */}
                                  The Matter Participants may act for and/or represent all of the Matter Clients for this Matter.
                                </div>
                              </label>
                              {errors['matter-participants-represent-clients'] && <p className="invalid">{errors['matter-participants-represent-clients'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    {watch('matter-participants-represent-clients') && <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="conflicts-or-separate-representation"
                                checked={watch("conflicts-or-separate-representation")}
                                {...register("conflicts-or-separate-representation", {
                                  required: "This field is required",
                                })}
                                onSelect={() => {
                                  setValue("conflicts-or-separate-representation", !getValues("conflicts-or-separate-representation"));
                                }}
                              />

                              <label className="custom-control-label" htmlFor="conflicts-or-separate-representation">
                                {/* <div>The image and audio samples are current and of the individual's face and voice.</div> */}
                                <div>
                                  If conflicts regarding the Matter arise or if the other Matter Clients do not agree to by jointly represented, you, one of the Matter Clients, may need to retain someone separate.
                                </div>
                              </label>
                              {errors['conflicts-or-separate-representation'] && <p className="invalid">{errors['conflicts-or-separate-representation'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>}
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="credit-report-authorization"
                                checked={watch("credit-report-authorization")}
                                {...register("credit-report-authorization")}
                                onSelect={() => {
                                  setValue("credit-report-authorization", !getValues("credit-report-authorization"));
                                  // console.log(watch("third_party"));
                                }}
                              />

                              <label className="custom-control-label" htmlFor="credit-report-authorization">
                                <div>
                                  If this Matter requires your credit report (e.g. for a loan, tenancy, verify your financial standing), any of the Matter Participants may obtain it from any credit-reporting agency.
                                </div>
                              </label>
                              {errors['credit-report-authorization'] && <p className="invalid">{errors['credit-report-authorization'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="tenancy-history-verification"
                                checked={watch("tenancy-history-verification")}
                                {...register("tenancy-history-verification")}
                                onSelect={() => {
                                  setValue("tenancy-history-verification", !getValues("tenancy-history-verification"));
                                }}
                              />

                              <label className="custom-control-label" htmlFor="tenancy-history-verification">
                                <div>
                                  If this Matter requires verifying your tenancy history (e.g. for a new tenancy, proving where you live), any of the Matter Participants may contact your previous or current landlord.
                                </div>
                              </label>
                              {errors['tenancy-history-verification'] && <p className="invalid">{errors['tenancy-history-verification'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ paddingLeft: "45px", paddingBottom: "10px" }} className="custom-control-group ">
                        <div className="custom-control custom-checkbox">
                          <div style={{ paddingBottom: "10px" }} className="custom-control-group ">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="employment-history-verification"
                                checked={watch("employment-history-verification")}
                                {...register("employment-history-verification")}
                                onSelect={() => {
                                  setValue("employment-history-verification", !getValues("employment-history-verification"));
                                }}
                              />

                              <label className="custom-control-label" htmlFor="employment-history-verification">
                                <div>
                                  If this Matter requires verifying your employment history (e.g. for a loan, proof of income, applying for a new job), any of the Matter Particpants may contact your previous or current emplohyer (except with respect to a new job).
                                </div>
                              </label>
                              {errors['employment-history-verification'] && <p className="invalid">{errors['employment-history-verification'].message}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>

                    <h6 className="mt-3">Your Signature</h6>
                    <div className="p-1">
                      <Button
                        onClick={(e) => onClear(e)}
                        color="primary"
                        size=""
                        className=""
                        href="ccr/verify/complete"
                        type="button"
                        outline=""
                      >
                        Clear
                      </Button>
                    </div>
                    {signError && <h3 className="text-danger">Please Sign</h3>}
                    <div className="border">

                      <SignatureCanvas
                        penColor="black"
                        canvasProps={{
                          height: 600,
                          className: "sigCanvas",
                        }}
                        ref={signPad}
                      />
                    </div>

                    {/* <div className="mt-3 nk-kycfm-note">
                    <em className=" icon ni ni-info-fill"></em>
                    <p>You cannot edit your details once submitted.</p>
                  </div> */}
                  </div>
                </div>
                <div className="bg-primary" style={{ position: "fixed", bottom: "0px" }}>
                  <div className="bg-white col-12" style={{ position: "fixed", bottom: "0px", right: "0px" }}>
                    <div style={{ margin: "10px 5px 10px 0px", float: "right" }} className="p-1">
                      {" "}
                      <Button color="primary" size="" className={submitButtonLoading && "disabled"} outline="">
                        {submitButtonLoading && <Spinner size="sm" />} Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </Block>
          </div>
        </Content>
      )}
      {/* <ToastContainer /> */}
    </React.Fragment>
  );
};

export default AmlConsent;
